export default __webpack_public_path__ + "static/media/PeopleLens_Logo.97939c62.svg";